module.exports = __webpack_public_path__ + "static/img/enter-plan-picture3.9efb88d4.png";